import config from "../../../config";
import React from "react";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { handleResponseArray } from "./APIHandlerHelper";
import { Region, RegionSubmission } from "../interfaces/Region";

interface Props {
  onAuthError?: () => void;
}

export default class SiteAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.META_API}/api/sites/`;

  getSitesByCompanyId = (companyId: number): Promise<Region[]> => {
    const apiSites = `${SiteAPIs.BASE_URL}children/region/${companyId}`;

    return this.apiResponseHandler.get(apiSites).then((data) => handleResponseArray(data));
  };

  createSite = async (siteSubmission: RegionSubmission): Promise<number> => {
    const apiSites = `${SiteAPIs.BASE_URL}`;
    return this.apiResponseHandler.post(apiSites, JSON.stringify(siteSubmission.region), false);
  };

  deleteSite = async (siteId: number): Promise<null> => {
    const apiSites = `${SiteAPIs.BASE_URL}${siteId}`;
    return this.apiResponseHandler.delete(apiSites, false);
  };
}
